import React from 'react';
import HomeComponent from '../../components/homeComponents/Home';

const Index = () => {
	return <HomeComponent />;
};

export default Index;
